import { OperatorTypes } from '@avtechsoftware/ra-javascript-utilities/src/types/OperatorTypes';
import momentTz from 'moment-timezone';
import BaseFacet from '../BaseFacet/BaseFacet';
import FacetType from '../../../utility/types/facetType';
import { facetTypeDetails } from '../../../utility/types/facetTypeDetails';

class ChannelLastReadingTimestampFacet extends BaseFacet {
  constructor() {
    super();
    this.facetType = FacetType.CHANNEL_LAST_READING_TIMESTAMP;
    this.displayName = 'Channel Last Reading';
    this.description = 'Include channels that...';
  }

  // eslint-disable-next-line class-methods-use-this
  getOperatorDescription(operatorType) {
    const operatorDescriptions = {
      [OperatorTypes.BETWEEN]: 'Last reading during this time period:',
      [OperatorTypes.NOT_BETWEEN]: 'Last reading NOT during this time period:',
    };
    return operatorDescriptions[operatorType] || '';
  }

  // eslint-disable-next-line class-methods-use-this
  getDisplayValue1(value) {
    const intValue = parseInt(value, 10);
    return momentTz.unix(intValue).format('MM/DD/YYYY');
  }

  // eslint-disable-next-line class-methods-use-this
  fromDisplayValue1(value) {
    return momentTz(value, 'MM/DD/YYYY').unix();
  }

  // eslint-disable-next-line class-methods-use-this
  getDisplayValue2(value) {
    const intValue = parseInt(value, 10);
    return momentTz.unix(intValue).format('MM/DD/YYYY');
  }

  // eslint-disable-next-line class-methods-use-this
  fromDisplayValue2(value) {
    return momentTz(value, 'MM/DD/YYYY').unix();
  }

  getOperatorSelectOptions() {
    const facet = facetTypeDetails[this.facetType];
    return [
      {
        value: facet.validOperators[0],
        label: this.getOperatorDescription(facet.validOperators[0]),
      },
      {
        value: facet.validOperators[1],
        label: this.getOperatorDescription(facet.validOperators[1]),
      },
    ];
  }

  // eslint-disable-next-line class-methods-use-this
  getTooltip(filtersByOperatorObj) {
    // TODO for less than 24 hours , display "last x hours"
    if (filtersByOperatorObj && Object.values(filtersByOperatorObj).length) {
      const filtersArray = Object.values(filtersByOperatorObj)[0];
      const filter = filtersArray[0];
      const operatorString = filter.operatorId === OperatorTypes.BETWEEN
        ? 'Last reading during '
        : 'Last reading NOT during ';
      return `${operatorString} ${this.getDisplayValue1(filter.value1)} - ${this.getDisplayValue2(filter.value2)}`;
    }
    return '';
  }
}
export default ChannelLastReadingTimestampFacet;
